var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAdminReporter(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8C8C8C",
    d: "M2.404 5.038c.047-.03.093-.015.14.015.326.274 1.056.594 1.056.594l.466.67-.31 2.374.745.913.745-.913-.31-2.374.465-.655c.404-.122.777-.304 1.103-.563.03-.03.093-.03.14-.015 1.009.502 1.832 1.324 2.329 2.359.046.091.031.213-.031.304-1.01 1.385-2.64 2.268-4.473 2.253-1.832-.015-3.447-.944-4.425-2.344-.047-.076-.062-.198-.016-.29.513-1.034 1.351-1.84 2.376-2.328zM4.516 0c1.429.015 2.562 1.157 2.562 2.542-.015 1.385-1.18 2.511-2.593 2.496-1.413-.015-2.562-1.157-2.547-2.542C1.938 1.111 3.103-.015 4.516 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminReporter);
export default __webpack_public_path__ + "static/media/admin-reporter.47c74d68.svg";
export { ForwardRef as ReactComponent };